module.exports = __webpack_public_path__ + "static/media/digital_signature.2c528171.svg";